
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-integrations/moengage",
      function () {
        return require("private-next-pages/whatsapp-integrations/moengage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-integrations/moengage"])
      });
    }
  